module.exports = __webpack_public_path__ + "img/1f9aa.89d79cd.svg";